
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 3l3.59 3.59M21 21l-3.588-3.589m-3.536 1.414C13.268 18.94 12.642 19 12 19c-4.477 0-8.268-2.943-9.542-7a9.97 9.97 0 011.563-3.029m5.857.908a3 3 0 114.243 4.243M9.88 9.878l4.243 4.242M9.88 9.88l-3.29-3.29m7.533 7.532L6.59 6.59m7.532 7.532l3.29 3.29M6.59 6.59A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.542 7a10.024 10.024 0 01-4.131 5.411","stroke":"#949494","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    